import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export const teamMembers = () => {
	imagePosition()
	switchSrc()
}

const imagePosition = () => {

	let els = document.querySelectorAll('[data-el="floating-image"]')

	if (!els.length || window.innerWidth < 960) return

	els.forEach(el => {

		let end = '+=' + (el.parentElement.parentElement.offsetHeight - el.parentElement.offsetHeight)

		ScrollTrigger.create({
			trigger: el.parentElement,
			start: 'center center',
			end: end,
			endTrigger: el.parentElement.parentElement,
			pin: true,
			// markers: true,
		})
	})
}

const switchSrc = () => {

	let els = document.querySelectorAll('[data-animation="team-members"]')

	if (!els.length || window.innerWidth < 960) return

	els.forEach(el => {

		let floatingImage = document.querySelector('[data-el="floating-image"]'),
			items = el.querySelectorAll('[data-image]')

		items.forEach((item) => {
			item.addEventListener("mouseenter", () => {
				let src = item.getAttribute('data-image')
				if (src) {
					floatingImage.src = src
					floatingImage.parentElement.dataset.status = 'visible'
				}
			})

			item.addEventListener('mouseleave', () => {
				floatingImage.parentElement.dataset.status = 'hidden'
			})
		})
	})
}

export default () => { }